module.exports = __webpack_public_path__ + "static/media/megamill.dd2a7598.png";